import type React from 'react';

import * as styles from './styles';
import ChecklistItemIconButton from './ChecklistItemIconButton';
import type { ChecklistFormProps } from './formProps';
import { ErrorMessage, FastField, useFormikContext } from 'formik';

import { CaptionError, DefaultInput } from '@cobliteam/base-components';

import CancelRoundedIcon from '@mui/icons-material/CancelRounded';

const getChecklistOptionLabelMetadata = (checklistOptionsMd: string, index: number) => `${checklistOptionsMd}[${index}].label`;

export interface ChecklistItemOptionProps {
  index: number;
  hasMultipleOptions: boolean;
  optionsMd: string;
  handleDeleteClick: () => void;
}

const ChecklistItemOption: React.FC<ChecklistItemOptionProps> = ({ index, hasMultipleOptions, optionsMd, handleDeleteClick }) => {
  const { handleChange, getFieldMeta } = useFormikContext<ChecklistFormProps>();
  const checklistOptionLabelMd = getChecklistOptionLabelMetadata(optionsMd, index);
  const optionPlaceholder = `Opção ${index + 1}`;

  return (
    <div className={styles.checklistItemOption}>
      <div className={styles.checklistItemOptionInput}>
        <FastField
          onChange={handleChange}
          name={checklistOptionLabelMd}
          error={getFieldMeta(checklistOptionLabelMd).touched && Boolean(getFieldMeta(checklistOptionLabelMd).error)}
          placeholder={optionPlaceholder}
          fullWidth
          as={DefaultInput}
        />
        {hasMultipleOptions && (
          <ChecklistItemIconButton disableRipple onClick={handleDeleteClick}>
            <CancelRoundedIcon />
          </ChecklistItemIconButton>
        )}
      </div>
      <div className={styles.inputErrorMessage}>
        <ErrorMessage name={checklistOptionLabelMd}>{(msg) => <CaptionError>{msg}</CaptionError>}</ErrorMessage>
      </div>
    </div>
  );
};

export default ChecklistItemOption;
